import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { useState } from 'react';
import { getItemWithExpiration } from '../lib/utils';

type QueryConfig = {
    fetchFn: (
        params: any,
        authorization: string
    ) => {
        queryKey: any[];
        queryFn: () => Promise<any>;
        onSuccess?: (data: any) => any;
    };
    params: any;
    enabled?: boolean;
    suspense?: boolean;
    cacheTime?: number;
};

const useSingleQuery = (query: QueryConfig) => {
    const [authorization, setAuthorization] = useState(getItemWithExpiration('authorization'));
    const { queryKey, queryFn, onSuccess } = query.fetchFn(query.params, authorization);

    const queryOptions: UseQueryOptions = {
        queryKey,
        queryFn,
        enabled: !!authorization && !!query.enabled,
        onSuccess,
        suspense: query.suspense ?? true,
        cacheTime: query.cacheTime,
        keepPreviousData: true,
    };

    const result = useQuery(queryOptions);

    const refinedResult =
        result.isSuccess && onSuccess
            ? {
                  ...result,
                  data: onSuccess(result.data),
              }
            : result;

    return {
        refinedResult,
        /**
         * onSuccess로 정제하기 **전**의 원본 응답.
         *
         * refinedResult는 `data`를 정제 결과로 덮어써서, 응답 본문에 함께 실려 온
         * 형제 키(예: 수강권 상세의 `shareLifecycle`)에 닿을 방법이 없다.
         * 정제 계약은 그대로 두고 원본만 추가로 노출한다(기존 호출부 영향 없음).
         */
        rawData: result.data,
        isLoading: result.isLoading,
        isFetching: result.isFetching,
        refresh: result.refetch,
    };
};

export default useSingleQuery;
